import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { useIncentive } from '../../hooks/Features/useIncentive'
import { formatNumber } from '../../shared/constants'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

export default function IncentiveReport() {
  const { getIncentiveReport, loading, paginate, incentives, getPdfCsvData, downloadLoading, pdfCsvData, downloadKeys } = useIncentive()

  const [searchQuery, setSearchQuery] = useState('')

  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  startDate.setMonth(1)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())

  const [page, setPage] = React.useState(1)

  const [filterParams, setFilterParams] = useState({ storeName: null, firstName: 1 })

  const noOfPages = paginate.totalPage

  useEffect(() => {
    getIncentiveReport({ from, to, ...filterParams, searchQuery, page })
  }, [from, to, filterParams, searchQuery, page])

  useEffect(() => {
    getPdfCsvData(downloadKeys.INCENTIVE_REPORT, { from, to })
  }, [from, to])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let schemeHeading = []
  let schemeHeadingTargetBased = []

  let columnSpan = {}

  if (!loading && incentives.length) {
    incentives[0].allSchemeOfStore.forEach((scheme) => {
      if (scheme.schemeType !== 'TARGET BASED') {
        schemeHeading.push(scheme.name)
        columnSpan[scheme.name] = 2
      } else {
        schemeHeadingTargetBased.push(scheme.name)
        columnSpan[scheme.name] = 4
      }
    })
  }

  const tableHeading = ['Employee', 'Store', 'Store Type', ...schemeHeading, ...schemeHeadingTargetBased, 'Total Incentive']
  const subHeading = ['Sales', 'Incentive Amt']
  const subHeadingTargetBased = ['Quaterly Target', 'Sales', '%', 'Incentive Amt']

  return (
    <Layout
      heading="Incentive Report"
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      filename="incentive-report"
      downloadLoading={downloadLoading}
    >
      <CustomTable>
        <CustomTableHeading setFilterParams={setFilterParams} filterParams={filterParams} heading={tableHeading} columnSpan={columnSpan} />
        {!loading && incentives.length > 0 && (
          <CustomTableRow>
            <TableCell colSpan={3}></TableCell>
            {schemeHeading.map((val) => {
              return subHeading.map((item, index) => {
                return <TableCell style={{ borderLeft: index === 0 ? '1px solid black' : 'none' }}>{item}</TableCell>
              })
            })}
            {schemeHeadingTargetBased.map((val) => {
              return subHeadingTargetBased.map((item, index) => {
                return <TableCell style={{ borderLeft: index === 0 ? '1px solid black' : 'none' }}>{item}</TableCell>
              })
            })}
            <TableCell></TableCell>
          </CustomTableRow>
        )}
        <TableBody>
          {!loading &&
            incentives.length > 0 &&
            incentives.map((item, index) => {
              return (
                <CustomTableRow key={index}>
                  <TableCell> {item.employeeName} </TableCell>
                  <TableCell> {item.storeName} </TableCell>
                  <TableCell> {item.storeType} </TableCell>
                  {item.allSchemeOfStore.map(
                    (val) =>
                      val.schemeType !== 'TARGET BASED' && (
                        <React.Fragment>
                          <TableCell> {formatNumber(val.totalSaleAmount)} </TableCell>
                          <TableCell>{formatNumber(val.incentiveStoreWillGet)}</TableCell>
                        </React.Fragment>
                      )
                  )}
                  {item.allSchemeOfStore.map((val) => {
                    if (val.schemeType === 'TARGET BASED') {
                      // considering starting from jan
                      let quarter = Math.floor(new Date(from).getMonth() / 3)
                      let dat = quarter < val.schemeDuration.length ? val.schemeDuration[quarter] : {}
                      return (
                        <React.Fragment>
                          <TableCell>{formatNumber(dat.targetAmount)}</TableCell>
                          <TableCell> {formatNumber(dat.totalSaleAmount)} </TableCell>
                          <TableCell>{((dat.totalSaleAmount * 100) / dat.targetAmount).toFixed()}</TableCell>
                          <TableCell>{formatNumber(val.incentiveStoreWillGet)}</TableCell>
                        </React.Fragment>
                      )
                    }
                  })}
                  <TableCell>{formatNumber(item.incentiveStoreWillGet)}</TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>

      {!loading && incentives.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}

      {!loading && !incentives.length && <NoDataFound text="No Incentive Found" />}

      {loading && <Loader />}
    </Layout>
  )
}
